import { render, staticRenderFns } from "./MyAssessments.vue?vue&type=template&id=515ea4c0&"
import script from "./MyAssessments.vue?vue&type=script&lang=js&"
export * from "./MyAssessments.vue?vue&type=script&lang=js&"
import style0 from "./MyAssessments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports